import { useMemo } from 'react';
import { parseJSON } from '@icp/utils';
import { useDataSource, useVariablePattern } from '../../hooks';

function useAudioMarkers(props) {
  const { markersProp, markersDataSource, markersUseDataSource, duration, isInDesign } = props;

  const markersData = useVariablePattern(markersProp);

  const { dataFetched: markersDataFetched } = useDataSource({
    skip: isInDesign,
    ...markersDataSource.componentProps,
  });

  return useMemo(() => {
    if (isInDesign) return [];
    let result = markersData;
    if (markersUseDataSource) {
      result = markersDataFetched?.results;
    } else if (typeof markersData === 'string') {
      result = parseJSON(markersData);
    }
    if (Array.isArray(result)) {
      return result.filter((marker) => marker.time >= 0 && marker.time <= duration);
    }
    if (result != null) {
      console.error('Markers data should be an array, e.g. [{"time": 100, "label": "marker"}].');
    }
    return [];
  }, [isInDesign, markersData, markersUseDataSource, markersDataFetched?.results, duration]);
}

export default useAudioMarkers;
